const slugifyDashboardPart = (value, fallback = "n-a") => {
  const normalized = String(value || "").trim();
  if (!normalized || normalized.toUpperCase() === "N/A") return fallback;

  return normalized
    .toLowerCase()
    .replace(/\//g, "--")
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9&()-]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

/**
 * Every authenticated user gets one canonical dashboard URL. The API response
 * is the source of truth; no role is substituted with a fallback appointment.
 */
export const getDashboardRoute = ({ branch, subBranch, role }) => {
  const roleSlug = slugifyDashboardPart(role, "user");
  const subBranchSlug = slugifyDashboardPart(subBranch);

  // These appointments have dedicated dashboards registered under the legacy
  // Chief Clerk route family. Keep them on those specialized pages rather
  // than allowing the dynamic catch-all to render the generic clerk view.
  const dedicatedChiefClerkSections = new Set([
    "cis-sub-branch",
    "int-sub-branch",
    "ootw-sub-branch",
    "ops-sub-branch",
    "sys-sub-branch",
    "battalion",
    "sos-branch",
    "kacs",
  ]);

  if (roleSlug === "chief-clerk" && dedicatedChiefClerkSections.has(subBranchSlug)) {
    return `/dashboard/chief-clerk/${subBranchSlug}`;
  }

  return `/dashboard/${slugifyDashboardPart(branch)}/${subBranchSlug}/${roleSlug}`;
};

/**
 * Resolve the Home destination for the active authenticated session.
 * Server-confirmed identity wins for normal users, with the login snapshot in
 * localStorage used only while /api/users/me is still resolving.
 */
export const getSessionLandingRoute = (identity = null) => {
  if (typeof window === "undefined") return "/";

  const storage = window.localStorage;
  if (storage.getItem("adminToken")) return "/admin-dashboard";

  const hasUserSession = Boolean(
    storage.getItem("authToken") || window.sessionStorage?.getItem("authToken")
  );
  if (!hasUserSession) return "/";

  return getDashboardRoute({
    branch: identity?.branch || storage.getItem("branch"),
    subBranch:
      identity?.subBranch ||
      identity?.unitBranch ||
      storage.getItem("subBranch") ||
      storage.getItem("unitBranch"),
    role: identity?.role || storage.getItem("role"),
  });
};

export { slugifyDashboardPart };
